<div class="row">
    <div class="col-xl-9 col-lg-12">
        <div class="row">
            <div class="col-3">
            <span class="mb-3" style="width: 100%; display:inline-block">
                <ng-select
                [virtualScroll]="true"
                [items]="customProducts"
                bindLabel="newProductName"
                [(ngModel)]="searchedProduct"
                (ngModelChange)="onProductFound($event)">
                <ng-template ng-option-tmp let-item="item">
                    {{item.newProductName}}
                </ng-template>
                </ng-select>
            </span>
            <div>
                <ngx-datatable
                    id="customProductsTable"
                    class="material striped other"
                    style="height: calc(100vh - 310px);"
                    [columns]="productsColumns"
                    [columnMode]="'force'"
                    [headerHeight]="50"
                    [footerHeight]="40"
                    [rowHeight]="50"
                    [count]="customProducts ? customProducts.length : 0"
                    [rows]="customProducts"
                    [loadingIndicator]="isLoading"
                    [scrollbarV]="true"
                    [selectionType]="SelectionType.multiClick"
                    [selected]="selectedProducts"
                    [virtualization]="true"
                    (select)="syncDisplayedForms()"
                ></ngx-datatable>

            </div>
            </div>
            <div class="col-9">
                <div class="buttons d-flex flex-row-reverse mb-4">
                    <button class="btn btn-outline-primary btn-sm float-right" (click)="onAddProduct()">Add +</button>
                </div>
                <ul class="list-group" style="overflow-y: scroll; height: calc(100vh - 310px);">

                    <div *ngIf="currViewedFormProducts.length == 0">
                        <h3 style="color: #666;" class="text-center mt-5"> Select on the left or Add a New Product to show up here </h3>
                    </div>

                    <li class="list-group-item flex-column align-items-start mr-3"  *ngFor="let productForm of currViewedFormProducts">
                        <button type="button" class="close position-absolute" (click)="hideProductForm(productForm)" style="right: 1.25rem; top: .75rem;" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <form [formGroup]="productForm">
                            <span>Product Name:</span> <input formControlName="newProductName" class="form-control d-inline w-25 ml-1" type="text">
                            <span class="ml-3 mr-1">Product Type:</span>
                            <select formControlName="productType" class="form-control d-inline w-25">
                              <option *ngFor="let item of productTypes" value="{{item}}">{{item}}</option>
                            </select>
                            <h6 class="mt-4 mb-2">Conditionals:</h6>
                            <div class="conditionals-table table"  formArrayName="ruleMappings">
                                <div class="table-row form-group form-inline d-flex" *ngFor="let ruleMapping of productForm.get('ruleMappings').controls; index as i" [formGroupName]="i">
                                    <select formControlName="sourceFieldName" class="form-control flex-grow-1 mr-3">
                                        <option value="" disabled selected>Observed Field</option>
                                        <option *ngFor="let item of sourceFields" value="{{item}}">{{item}}</option>
                                    </select>

                                    <select  formControlName="condition" class="form-control flex-grow-2 mr-3">
                                        <option value="null" disabled selected>Conditional Field</option>
                                        <option *ngFor="let item of conditionalFields" value="{{item}}">{{item}}</option>
                                    </select>

                                    <input  formControlName="valueToMatch" class="form-control flex-grow-1 mr-3" type="text">
                                    <button class="btn btn-sm btn-outline-danger" (click)="onRemoveConditional(productForm, ruleMapping)"><i class=" fa fa-trash"></i></button>
                                </div>
                            </div>
                            <button class="btn btn-outline-primary btn-sm" (click)="onAddFormConditional(productForm.get('ruleMappings'))">Add +</button>
                        </form>
                        <div class="buttons float-right" style="margin-right: 50px;">
                            <button class="btn btn-primary mr-3" [ngClass]="{'disabled': !productForm.valid || !productForm.touched}" (click)="onSaveFormGroup(productForm)">Save</button>
                            <button class="btn btn-danger btn-outline" [ngClass]="{'disabled': !productForm.value.id}" (click)="onDeleteFormGroup(productForm)">Delete</button>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</div>

<error-handler></error-handler>
